import React from "react"
import * as S from "./custom-input.styles"
import { useFormContext, Controller } from "react-hook-form"
import { getRHFErrorMessage } from "../../utils/utils"

const CustomInput = ({
  title,
  name,
  validations,
  label,
  className,
  type = "text",
  variant = "outlined",
  multiline,
  defaultValue = "",
    uncontrolled,
  ...otherProps
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  if (!control || uncontrolled)
    return (
        <S.InputContainer className={className}>
          {title && <S.Title>{title}</S.Title>}
          <S.CustomInput
              required={!!validations?.required}
              variant={variant}
              label={label}
              type={type}
              multiline={multiline}
              {...otherProps}
          />
        </S.InputContainer>
    )


  const error = getRHFErrorMessage(errors, name)

  return (
    <S.InputContainer className={className}>
      {title && <S.Title>{title}</S.Title>}
      <Controller
        rules={validations}
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <S.CustomInput
            error={!!error}
            required={!!validations?.required}
            variant={variant}
            label={label}
            helperText={error}
            type={type}
            multiline={multiline}
            {...otherProps}
            {...field}
          />
        )}
      />
    </S.InputContainer>
  )
}

export default CustomInput
